import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import Header from '../Header/Header';
import MediaList from '../MediaList/MediaList';

//import icons from '../../data/icons';
import * as actions from '../../actions/index';
import './ReferenceDetail.css';

class ReferenceDetail extends React.Component {
  propTypes: {
    title: propTypes.string,
    projectName: propTypes.string,
    customer: propTypes.string,
    year: propTypes.string,
    tech: propTypes.string,
    tagline: propTypes.string,
    image: propTypes.string,
    customerLogo: propTypes.string,
    location: propTypes.string,
    benefits: propTypes.array,
    solutions: propTypes.array,
    media: propTypes.array,

    currentNews: propTypes.string,
    date: propTypes.datetime,
  }
  render() {
    return (
      <section className={"reference-story" + (this.props.currentNews === this.props._id ? ' selected' : '')}>
        <section className="author-panel">
          <div className="reference-customer-image">
            <img src={this.props.customerLogo} alt={this.props.customer} />
          </div>
          <table className="reference-table">
            <tbody>
              <tr>
                <td>Project: </td>
                <td className="content">{this.props.projectName}</td>
              </tr>
              <tr>
                <td>Location: </td>
                <td className="content">{this.props.location}</td>
              </tr>
              <tr>
                <td>Customer: </td>
                <td className="content">{this.props.customer}</td>
              </tr>
              <tr>
                <td>Year: </td>
                <td className="content">{this.props.year}</td>
              </tr>
            </tbody>
          </table>
          <MediaList media={this.props.media} />
        </section>
        <section className="content-panel">
          <Header
            title={this.props.categories[0]}
            subtitle={this.props.title}
          />
          {this.props.image && 
            <img className={'ReferenceDetail__heroImage'} src={this.props.image} alt={this.props.title} />
          }
          <h4 className="solutions-header">Solutions</h4>
          <section className="content">
            {this.props.solutions.map(solution => <div key={solution}>{solution}</div>)}
          </section>
          <h4 className="benefits-header">Customer Benefits</h4>
          <ul className="content">
            {this.props.benefits.map(benefit => <li key={benefit}>{benefit}</li>)}
          </ul>
        </section>
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setModal: (index) => {
      dispatch(actions.setModal(index));
    },
  };
}

export default connect(null, mapDispatchToProps)(ReferenceDetail);



// WEBPACK FOOTER //
// ./src/components/ReferenceDetail/ReferenceDetail.js